// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var MenuV5 = require("../../v5/common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var EventLogs = require("../EventLogs.bs.js");
var FeaturesV3 = require("../featureFlipper/FeaturesV3.bs.js");
var MediaQuery = require("../common/Media/MediaQuery.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../utils/ReactRender.bs.js");
var UserSession = require("../common/UserSession/UserSession.bs.js");
var Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var IsTouchDevice = require("is-touch-device");
var JsxRuntime = require("react/jsx-runtime");
var RequireAuthenticatedAgent = require("../../hoc/RequireAuthenticatedAgent.bs.js");
var RequireAuthenticatedClient = require("../../hoc/RequireAuthenticatedClient.bs.js");
var ClientAccess__Components__Avatar = require("../ClientAccess/components/ClientAccess__Components__Avatar.bs.js");

function ProfileDropdown$BaseMenu(props) {
  var buttonContentMobile = props.buttonContentMobile;
  var buttonContent = props.buttonContent;
  var isDesktop = MediaQuery.isDesktop();
  return JsxRuntime.jsx(MenuV5.Menu.make, {
              button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                    className: TailwindMerge.twMerge(["!border-none ml-[30px] !p-0 flex cursor-pointer relative !capitalize font-semibold"]),
                    children: Caml_option.some(JsxRuntime.jsx("div", {
                              children: buttonContentMobile !== undefined && !isDesktop ? Caml_option.valFromOption(buttonContentMobile) : buttonContent,
                              className: "flex flex-row items-center justify-start gap-4"
                            }))
                  }),
              children: props.children
            });
}

var BaseMenu = {
  make: ProfileDropdown$BaseMenu
};

function ProfileDropdown$DefaultMenu(props) {
  var handleSignout = props.handleSignout;
  return JsxRuntime.jsx(ProfileDropdown$BaseMenu, {
              buttonContent: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "Menu"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx(IconV5.make, {
                                  icon: "arrow-down",
                                  size: 20,
                                  className: "text-zinc-600"
                                }),
                            className: "align-baseline"
                          })
                    ],
                    className: "flex flex-row items-center justify-start gap-1.5"
                  }),
              children: JsxRuntime.jsx(MenuV5.MenuItem.make, {
                    onAction: (function () {
                        handleSignout();
                      }),
                    children: "Sign Out"
                  })
            });
}

var DefaultMenu = {
  make: ProfileDropdown$DefaultMenu
};

function ProfileDropdown$ClientMenu(props) {
  var handleSignout = props.handleSignout;
  var match = UserSession.useClientInfo();
  var clientProfilePicEnabled = FeaturesV3.useFeatureFlipper("CAP_ClientRegistration") === "on";
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs(ProfileDropdown$BaseMenu, {
                        buttonContent: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                clientProfilePicEnabled ? JsxRuntime.jsx(ClientAccess__Components__Avatar.make, {}) : null,
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("span", {
                                              children: match.firstName + " " + match.lastName
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(IconV5.make, {
                                                    icon: "arrow-down",
                                                    size: 14,
                                                    className: "text-zinc-400"
                                                  }),
                                              className: "align-baseline"
                                            })
                                      ],
                                      className: "flex flex-row items-center justify-start gap-1.5"
                                    })
                              ]
                            }),
                        buttonContentMobile: Caml_option.some(JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx(IconV5.make, {
                                              icon: "arrow-down",
                                              size: 20,
                                              className: "text-zinc-600"
                                            }),
                                        className: "align-baseline"
                                      }),
                                  className: "flex flex-row items-center justify-start gap-1.5"
                                })),
                        children: [
                          JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/client/account",
                                children: "Account Settings"
                              }),
                          JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                onAction: (function () {
                                    handleSignout();
                                  }),
                                children: "Sign Out"
                              })
                        ]
                      }))
            });
}

var ClientMenu = {
  make: ProfileDropdown$ClientMenu
};

function ProfileDropdown$AgentMenu(props) {
  var handleSignout = props.handleSignout;
  var agent = UserSession.useAgentInfo();
  var plan = UserSession.usePlan();
  var hasMembershipRequestPermission = UserSession.useHasPermission("MEMBERSHIP_REQUESTS");
  var marketingProfileSettingsEnabled = FeaturesV3.useFeatureFlipper("MarketingProfileSettings") === "on";
  var isTouch = IsTouchDevice();
  return JsxRuntime.jsxs(ProfileDropdown$BaseMenu, {
              buttonContent: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx(Avatar__Jsx3.make, {
                            src: UserSession.Agent.avatarUrl(agent, undefined, undefined),
                            name: UserSession.Agent.name(agent),
                            size: "small"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: UserSession.Agent.name(agent)
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(IconV5.make, {
                                          icon: "arrow-down",
                                          size: 14,
                                          className: "text-zinc-400"
                                        }),
                                    className: "align-baseline"
                                  })
                            ],
                            className: "ml-[10px] flex flex-row items-center justify-start gap-1.5"
                          })
                    ]
                  }),
              buttonContentMobile: Caml_option.some(JsxRuntime.jsx(Avatar__Jsx3.make, {
                        src: UserSession.Agent.avatarUrl(agent, undefined, undefined),
                        name: UserSession.Agent.name(agent),
                        size: "small"
                      })),
              children: [
                agent.tanStaff ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                        href: "/switch-chapter",
                        children: "Switch chapter"
                      }) : null,
                hasMembershipRequestPermission ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                        href: "/admin/add-qa",
                        children: "Add Qualified Agent"
                      }) : null,
                UserSession.Plan.isFree(plan) || UserSession.Plan.isTrial(plan) ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                        href: "/subscribe",
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(IconV5.make, {
                                            icon: "favorite",
                                            size: 20,
                                            className: "text-tan-gold-light"
                                          }),
                                      className: "mr-[5px] flex items-center justify-center"
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: UserSession.Plan.isTrial(plan) ? "Subscribe to Pro" : "Upgrade to Pro"
                                    })
                              ],
                              className: "flex flex-row items-center justify-start"
                            })
                      }) : null,
                (function (__x) {
                      return ReactRender.ifTrue(JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                      href: "/account/marketing_profile",
                                      children: JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: "Marketing Profile"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    className: "intercom_marketing-profile-dropdown-link",
                                                    onClick: (function (e) {
                                                        if (isTouch) {
                                                          e.preventDefault();
                                                          e.stopPropagation();
                                                          return ;
                                                        }
                                                        
                                                      })
                                                  })
                                            ],
                                            className: "flex items-center gap-2 "
                                          })
                                    }), __x);
                    })(marketingProfileSettingsEnabled),
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      href: "/account",
                      children: "Account Settings"
                    }),
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      href: "https://intercom.help/top-agent-network",
                      children: "Help Center"
                    }),
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      onAction: (function () {
                          handleSignout();
                        }),
                      children: "Sign Out"
                    })
              ]
            });
}

var AgentMenu = {
  make: ProfileDropdown$AgentMenu
};

function ProfileDropdown(props) {
  var handleSignout = props.handleSignout;
  var initState = UserSession.useInitState();
  var recordEvent = EventLogs.useRecordEventByCurrentUser();
  var handleSignout$p = function () {
    recordEvent(undefined, "Logout", undefined);
    handleSignout();
  };
  switch (initState) {
    case "Error" :
        return JsxRuntime.jsx(ProfileDropdown$DefaultMenu, {
                    handleSignout: handleSignout
                  });
    case "Agent" :
        return JsxRuntime.jsx(RequireAuthenticatedAgent.make, {
                    children: JsxRuntime.jsx(ProfileDropdown$AgentMenu, {
                          handleSignout: handleSignout$p
                        })
                  });
    case "Client" :
        return JsxRuntime.jsx(RequireAuthenticatedClient.make, {
                    children: JsxRuntime.jsx(ProfileDropdown$ClientMenu, {
                          handleSignout: handleSignout$p
                        })
                  });
    default:
      return null;
  }
}

var make = ProfileDropdown;

exports.BaseMenu = BaseMenu;
exports.DefaultMenu = DefaultMenu;
exports.ClientMenu = ClientMenu;
exports.AgentMenu = AgentMenu;
exports.make = make;
/* IconV5 Not a pure module */
